import { render, staticRenderFns } from "./App.vue?vue&type=template&id=8ce2d77a"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=8ce2d77a&prod&lang=less"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.5.3_webpack@4.47.0___3056130f5b7279a4bbaaeef265c7b87a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports